import api from "api/dictionariesApi";
import * as types from "../actionTypes";
import { sendHttpRequest } from "./httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { getLeasingExpenseTypes } from "features/offer/edit/financials/leasingExpenses/selectors";

function loadCurrenciesSuccess(currencies) {
  return { type: types.LOAD_CURRENCIES_SUCCESS, payload: currencies };
}
function loadCommissionTypesSuccess(commissionTypes) {
  return { type: types.LOAD_COMMISSION_TYPES_SUCCESS, payload: commissionTypes };
}
function loadResponsibleSuccess(responsible) {
  return { type: types.LOAD_RESPONSIBLE_SUCCESS, payload: responsible };
}

export function loadAccountManagers(search) {
  //no redux cache
  return () => api.getAccountManagers(search);
}

export function loadAccountManager(accountManagerId) {
  return () => api.getAccountManager(accountManagerId);
}

export function loadResponsibles(search, partnerId) {
  //no redux cache
  return dispatch => {
    try {
      return api.getResponsibles(search, partnerId);
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadRiskResponsibles() {
  return dispatch => {
    try {
      return api.getRiskResponsibles();
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadResponsible(responsibleId) {
  return async (dispatch, getState) => {
    let { responsibles } = getState().dictionaries;
    let responsible = responsibles.find(a => a.responsibleId === responsibleId);

    if (responsible) return responsible;

    try {
      responsible = await dispatch(sendHttpRequest(api.getResponsible(responsibleId)));
      dispatch(loadResponsibleSuccess(responsible));
      return responsible;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadSuppliers(search) {
  //no redux cache
  return dispatch =>
    api.getSuppliers(search).catch(error => {
      dispatch(showError(error.message, error.correlationId));
      return { options: [] };
    });
}
export function loadDealers(search) {
  //no redux cache
  return dispatch =>
  api.getDealers(search).catch(error => {
    dispatch(showError(error.message));
    return { options: [] };
  });
}
export function loadUsers(search, dealerId) {
  //no redux cache
  return () => api.getUsers(search, dealerId);
}

export function loadUserPartners(search) {
  //no redux cache
  return () => api.getUserPartners(search);
}

export function loadUserAssociatedPartners() {
  //no redux cache
  return dispatch =>
    api.getUserAssociatedPartners().catch(error => {
      dispatch(showError(error.message, error.correlationId));
      return Promise.resolve([]);
    });
}

export function loadPartners(search) {
  //no redux cache
  return () => api.getPartners(search);
}

export function loadPartnersFiltered(filters) {
  return async dispatch => {
    dispatch({ type: types.LOAD_PARTNERS_FILTERED_STARTED, payload: { filters } });
    try {
      let partners = await dispatch(sendHttpRequest(api.filterPartners(filters)));
      dispatch({ type: types.LOAD_PARTNERS_FILTERED_SUCCEEDED, payload: { partners } });
      return partners;
    } catch (error) {
      dispatch({ type: types.LOAD_PARTNERS_FILTERED_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDealer(dealerId) {
  return async (dispatch, getState) => {
    let { dealers } = getState().dictionaries;
    let dealer = dealers.find(a => a.dealerId === dealerId);
    if (dealer) {
      return dealer;
    }

    try {
      dealer = await dispatch(sendHttpRequest(api.getDealer(dealerId)));
      dispatch({ type: types.LOAD_DEALER_SUCCESS, payload: dealer });
      return dealer;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadUser(userId) {
  return async (dispatch, getState) => {
    let { users } = getState().dictionaries;
    let user = users.find(a => a.userId === userId);
    if (user) {
      return user;
    }

    try {
      user = await dispatch(sendHttpRequest(api.getUser(userId)));
      dispatch({ type: types.LOAD_USER_SUCCESS, payload: user });
      return user;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadUserPartner(partnerId) {
  return async (dispatch, getState) => {
    let { userPartners } = getState().dictionaries;
    let partner = userPartners.find(a => a.partnerId === partnerId);
    if (partner) {
      return partner;
    }

    try {
      partner = await dispatch(sendHttpRequest(api.getUserPartner(partnerId)));
      dispatch({ type: types.LOAD_USER_PARTNER_SUCCESS, payload: partner });
      return partner;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadSources() {
  return async (dispatch, getState) => {
    let sources = getState().currentOffer.sources;

    if (sources.isLoaded) return sources;

    try {
      sources = await dispatch(sendHttpRequest(api.getSources()));
      dispatch({ type: types.LOAD_OFFER_SOURCES_SUCCESS, payload: sources });
      return sources;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadReferenceInterests() {
  return async (dispatch, getState) => {
    let { referenceInterests } = getState().dictionaries;
    if (referenceInterests.loading || referenceInterests.isLoaded) return;

    try {
      dispatch({ type: types.LOAD_OFFER_REFERENCE_INTERESTS_STARTED });
      referenceInterests = await dispatch(sendHttpRequest(api.getReferenceInterests()));
      dispatch({ type: types.LOAD_OFFER_REFERENCE_INTERESTS_SUCCESS, payload: referenceInterests });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadRiskAnalysisTypes(documentTypeId, prevDocumentTypeId) {
  return async (dispatch, getState) => {
    let { riskAnalysisTypes } = getState().dictionaries;
    if ((riskAnalysisTypes.isLoaded || riskAnalysisTypes.loading) && documentTypeId === prevDocumentTypeId?.current)
      return riskAnalysisTypes.items;

    try {
      dispatch({ type: types.LOAD_RISK_ANALYSIS_TYPES_STARTED });
      riskAnalysisTypes = await dispatch(sendHttpRequest(api.getRiskAnalysisTypes(documentTypeId)));
      dispatch({ type: types.LOAD_RISK_ANALYSIS_TYPES_SUCCESS, payload: riskAnalysisTypes });
      return riskAnalysisTypes;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPriceTypes() {
  return async (dispatch, getState) => {
    let { priceTypes } = getState().dictionaries;
    if (priceTypes.isLoaded || priceTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_PRICE_TYPES_STARTED });
      priceTypes = await dispatch(sendHttpRequest(api.getPriceTypes()));
      dispatch({ type: types.LOAD_PRICE_TYPES_SUCCESS, payload: priceTypes });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadLegalForms() {
  return async (dispatch, getState) => {
    let { legalForms } = getState().dictionaries;
    if (legalForms.isLoaded || legalForms.loading) return;

    try {
      dispatch({ type: types.LOAD_PARTNER_LEGAL_FORMS_STARTED });
      legalForms = await dispatch(sendHttpRequest(api.getLegalForms()));
      dispatch({ type: types.LOAD_PARTNER_LEGAL_FORMS_SUCCESS, payload: legalForms });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDimensionPeriods() {
  return async (dispatch, getState) => {
    let { dimensionPeriods } = getState().dictionaries;
    if (dimensionPeriods.isLoaded || dimensionPeriods.loading) return;

    try {
      dispatch({ type: types.LOAD_DIMENSION_PERIODS_STARTED });
      dimensionPeriods = await dispatch(sendHttpRequest(api.getDimensionPeriods()));
      dispatch({ type: types.LOAD_DIMENSION_PERIODS_SUCCESS, payload: dimensionPeriods });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDocumentScoringCategoryOptions() {
  return async (dispatch, getState) => {
    let { scoringCategoryOptions } = getState().dictionaries;
    if (scoringCategoryOptions.isLoaded || scoringCategoryOptions.loading) return;

    try {
      dispatch({ type: types.LOAD_SCORING_CATEGORY_OPTIONS_STARTED });
      const options = await dispatch(sendHttpRequest(api.getScoringCategoryOptions()));
      dispatch({ type: types.LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS, payload: options });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadChannels() {
  return async (dispatch, getState) => {
    let channels = getState().dictionaries.channels;
    if (channels.isLoaded) return channels.items;

    try {
      let channels = await dispatch(sendHttpRequest(api.getChannels()));
      dispatch({ type: types.LOAD_OFFER_CHANNELS_SUCCESS, payload: { channels } });
      return channels;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadStates(documentTypeId) {
  return async (dispatch, getState) => {
    let documentTypeId_states = getState().dictionaries.states[documentTypeId];
    if (documentTypeId_states?.isLoaded) return documentTypeId_states.states;

    try {
      let states = await dispatch(sendHttpRequest(api.getStates(documentTypeId)));
      dispatch({ type: types.LOAD_STATES_SUCCESS, payload: { states }, documentTypeId: documentTypeId });
      return states;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferVisibilityLevels() {
  return async (dispatch, getState) => {
    const cacheVisibilityLevels = getState().dictionaries.offerVisibilityLevels;
    if (cacheVisibilityLevels.loading) return;
    if (cacheVisibilityLevels.isLoaded) return cacheVisibilityLevels.items;

    try {
      const visibilityLevels = await dispatch(sendHttpRequest(api.getOfferVisibilityLevels()));
      dispatch({ type: types.LOAD_OFFER_VISIBILITY_LEVELS_SUCCESS, payload: visibilityLevels });
      return visibilityLevels;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadFolderVisibilityLevels() {
  return async (dispatch, getState) => {
    const cacheVisibilityLevels = getState().dictionaries.folderVisibilityLevels;
    if (cacheVisibilityLevels.loading) return;
    if (cacheVisibilityLevels.isLoaded) return cacheVisibilityLevels.items;

    try {
      const visibilityLevels = await dispatch(sendHttpRequest(api.getFolderVisibilityLevels()));
      dispatch({ type: types.LOAD_FOLDER_VISIBILITY_LEVELS_SUCCESS, payload: visibilityLevels });
      return visibilityLevels;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPartnerFileVisibilityLevels() {
  return async (dispatch, getState) => {
    const cacheVisibilityLevels = getState().dictionaries.partnerFileVisibilityLevels;
    if (cacheVisibilityLevels.loading) return;
    if (cacheVisibilityLevels.isLoaded) return cacheVisibilityLevels.items;

    try {
      const visibilityLevels = await dispatch(sendHttpRequest(api.getPartnerFileVisibilityLevels()));
      dispatch({ type: types.LOAD_PARTNER_FILE_VISIBILITY_LEVELS_SUCCESS, payload: visibilityLevels });
      return visibilityLevels;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadBankAccountTypes() {
  return async (dispatch, getState) => {
    const cachebankAccountTypes = getState().dictionaries.bankAccountTypes;
    if (cachebankAccountTypes.isLoaded || cachebankAccountTypes.loading) {
      return;
    }

    try {
      dispatch({ type: types.LOAD_BANK_ACCOUNT_TYPES_STARTED });
      const bankAccountTypes = await dispatch(sendHttpRequest(api.getBankAccountTypes()));
      dispatch({ type: types.LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED, payload: bankAccountTypes });
    } catch (error) {
      dispatch({ type: types.LOAD_BANK_ACCOUNT_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAddressTypes() {
  return async (dispatch, getState) => {
    const cachedAddressTypes = getState().dictionaries.addressTypes;
    if (cachedAddressTypes.isLoaded || cachedAddressTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_ADDRESS_TYPES_STARTED });
      const addressTypes = await dispatch(sendHttpRequest(api.getAddressTypes()));
      dispatch({ type: types.LOAD_ADDRESS_TYPES_SUCCEEDED, payload: addressTypes });
    } catch (error) {
      dispatch({ type: types.LOAD_ADDRESS_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadVerificationTypes() {
  return async (dispatch, getState) => {
    const cachedVerificationTypes = getState().dictionaries.verificationTypes;
    if (cachedVerificationTypes.isLoaded || cachedVerificationTypes.loading) return;
    try {
      dispatch({ type: types.LOAD_VERIFICATION_TYPES_STARTED });
      const verificationTypes = await dispatch(sendHttpRequest(api.getVerificationTypes()));
      dispatch({ type: types.LOAD_VERIFICATION_TYPES_SUCCEEDED, payload: verificationTypes });
    } catch (error) {
      dispatch({ type: types.LOAD_VERIFICATION_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadChecklists() {
  return async (dispatch, getState) => {
    const cachedChecklists = getState().dictionaries.checklists;
    if (cachedChecklists.isLoaded || cachedChecklists.items.length > 0) return;
    try {
      const checklists = await dispatch(sendHttpRequest(api.getChecklists()));
      dispatch({ type: types.LOAD_CHECKLISTS_SUCCEEDED, payload: checklists });
    } catch (error) {
      dispatch({ type: types.LOAD_CHECKLISTS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadSignatureRoles() {
  return async (dispatch, getState) => {
    const cachedSignatureRoles = getState().dictionaries.signatureRoles;
    if (cachedSignatureRoles.isLoaded || cachedSignatureRoles.loading) return;

    try {
      dispatch({ type: types.LOAD_SIGNATURE_ROLES_STARTED });
      const singatureRoles = await dispatch(sendHttpRequest(api.getSignatureRoles()));
      dispatch({ type: types.LOAD_SIGNATURE_ROLES_SUCCEEDED, payload: singatureRoles });
    } catch (error) {
      dispatch({ type: types.LOAD_SIGNATURE_ROLES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadInterestTypes() {
  return async (dispatch, getState) => {
    const cachedInterestTypes = getState().dictionaries.interestTypes;
    if (cachedInterestTypes.isLoaded || cachedInterestTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_INTEREST_TYPES_STARTED });
      const interestTypes = await dispatch(sendHttpRequest(api.getInterestTypes()));
      dispatch({ type: types.LOAD_INTEREST_TYPES_SUCCEEDED, payload: interestTypes });
    } catch (error) {
      dispatch({ type: types.LOAD_INTEREST_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadGenderTypes() {
  return async (dispatch, getState) => {
    const cachedGenderTypes = getState().dictionaries.genderTypes;
    if (cachedGenderTypes.isLoaded || cachedGenderTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_GENDER_TYPES_STARTED });
      const genderTypes = await dispatch(sendHttpRequest(api.getGenderTypes()));
      dispatch({ type: types.LOAD_GENDER_TYPES_SUCCEEDED, payload: genderTypes });
    } catch (error) {
      dispatch({ type: types.LOAD_GENDER_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCurrencies() {
  return async (dispatch, getState) => {
    let currencies = getState().dictionaries.currencies;
    if (currencies.isLoaded || currencies.loading) return currencies.items;

    try {
      dispatch({ type: types.LOAD_CURRENCIES_STARTED });
      currencies = await dispatch(sendHttpRequest(api.getCurrencies()));
      dispatch(loadCurrenciesSuccess(currencies));
      return currencies;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadCommissionTypes() {
  return async (dispatch, getState) => {
    let { commissionTypes } = getState().dictionaries;
    if (commissionTypes.isLoaded || commissionTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_COMMISSION_TYPES_STARTED });
      commissionTypes = await dispatch(sendHttpRequest(api.getCommissionTypes()));
      dispatch(loadCommissionTypesSuccess(commissionTypes));
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadLeasingExpenseTypes(documentId, siteId) {
  const key = `${documentId}-${siteId}`;

  return async (dispatch, getState) => {
    let { loading, loaded } = getLeasingExpenseTypes(key, getState());
    let shouldCallApi = !loaded && !loading;
    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: types.LOAD_LEASING_EXPENSE_TYPES_STARTED, key });

    try {
      const response = await dispatch(sendHttpRequest(api.getLeasingExpenseTypes(documentId, siteId)));
      dispatch({
        type: types.LOAD_LEASING_EXPENSE_TYPES_SUCCESS,
        key,
        response: [...response]
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadApprovalTypes() {
  return async (dispatch, getState) => {
    let { approvalTypes } = getState().dictionaries;
    if (approvalTypes.isLoaded) return approvalTypes.items;

    try {
      approvalTypes = await dispatch(sendHttpRequest(api.getApprovalTypes()));
      dispatch({ type: types.LOAD_APPROVAL_TYPES_SUCCESS, payload: approvalTypes });
      return approvalTypes;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadFinancingTypes() {
  return async (dispatch, getState) => {
    let financingTypes = getState().dictionaries.financingTypes;
    if (financingTypes.isLoaded) return financingTypes.items;

    try {
      financingTypes = await dispatch(sendHttpRequest(api.getFinancingTypes()));
      dispatch({ type: types.LOAD_FINANCING_TYPES_SUCCESS, payload: { financingTypes } });
      return financingTypes;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferTypes(documentTypeId) {
  return async (dispatch, getState) => {
    let documentTypeId_offerTypes = getState().dictionaries.offerTypes[documentTypeId];
    if (documentTypeId_offerTypes && documentTypeId_offerTypes.isLoaded) return documentTypeId_offerTypes.offerTypes;

    try {
      let offerTypes = await dispatch(sendHttpRequest(api.getOfferTypes(documentTypeId)));
      dispatch({ type: types.LOAD_OFFER_TYPES_SUCCESS, payload: { offerTypes }, documentTypeId: documentTypeId });
      return offerTypes;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadDecisionTypes() {
  return async (dispatch, getState) => {
    let { decisionTypes } = getState().dictionaries;
    if (decisionTypes.isLoaded || decisionTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_OFFER_DECISION_TYPES_STARTED });
      decisionTypes = await dispatch(sendHttpRequest(api.getOfferDecisionTypes()));
      dispatch({ type: types.LOAD_OFFER_DECISION_TYPES_SUCCESS, payload: decisionTypes });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadWarrantyTypes() {
  return async (dispatch, getState) => {
    let { warrantyTypes } = getState().dictionaries;
    if (warrantyTypes.isLoaded || warrantyTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_WARRANTY_TYPES_STARTED });
      warrantyTypes = await dispatch(sendHttpRequest(api.getWarrantyTypes()));
      dispatch({ type: types.LOAD_WARRANTY_TYPES_SUCCESS, payload: warrantyTypes });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPartnerPriorities() {
  return async (dispatch, getState) => {
    let partnerPriorities = getState().dictionaries.partnerPriorities;

    if (partnerPriorities.isLoaded) return partnerPriorities.items;

    try {
      partnerPriorities = await dispatch(sendHttpRequest(api.getOfferPriorities()));
      dispatch({ type: types.LOAD_PARTNER_PRIORITIES_SUCCESS, payload: partnerPriorities });
      return partnerPriorities;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadTransactionCategories() {
  return async (dispatch, getState) => {
    let { transactionCategories } = getState().dictionaries;
    if (transactionCategories.isLoaded) return transactionCategories.items;

    try {
      transactionCategories = await dispatch(sendHttpRequest(api.getTransactionCategories()));
      dispatch({ type: types.LOAD_TRANSACTION_CATEGORIES_SUCCESS, payload: transactionCategories });
      return transactionCategories;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadCountries() {
  return async (dispatch, getState) => {
    let { countries } = getState().dictionaries;
    if (countries.isLoaded) return countries.items;

    try {
      countries = await dispatch(sendHttpRequest(api.getCountries()));
      dispatch({ type: types.LOAD_COUNTRIES_SUCCESS, payload: countries });
      return countries;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
export function loadCounties() {
  return async (dispatch, getState) => {
    let { counties } = getState().dictionaries;
    if (counties.isLoaded) return counties.items;

    try {
      counties = await dispatch(sendHttpRequest(api.getCounties()));
      dispatch({ type: types.LOAD_COUNTIES_SUCCESS, payload: counties });
      return counties;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadCities() {
  return async (dispatch, getState) => {
    let { cities } = getState().dictionaries;
    if (cities.isLoaded) return cities.items;

    try {
      cities = await dispatch(sendHttpRequest(api.getCities()));
      dispatch({ type: types.LOAD_CITIES_SUCCESS, payload: cities });
      return cities;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPartnerRoles() {
  return async (dispatch, getState) => {
    let { partnerRoles } = getState().dictionaries;
    if (partnerRoles.isLoaded || partnerRoles.loading) return;

    try {
      dispatch({ type: types.LOAD_PARTNER_ROLES_STARTED });
      partnerRoles = await dispatch(sendHttpRequest(api.getPartnerRoles()));
      dispatch({ type: types.LOAD_PARTNER_ROLES_SUCCEEDED, payload: partnerRoles });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadActivityFields() {
  return async (dispatch, getState) => {
    let { activityFields } = getState().dictionaries;
    if (activityFields.isLoaded) return activityFields;

    try {
      activityFields = await dispatch(sendHttpRequest(api.getActivityFields()));
      dispatch({ type: types.LOAD_ACTIVITY_FIELDS_SUCCEEDED, payload: activityFields });
      return activityFields;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadContractTypes() {
  return async (dispatch, getState) => {
    const cachedContractTypes = getState().dictionaries.contractTypes;
    if (cachedContractTypes.isLoaded || cachedContractTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_CONTRACT_TYPES_STARTED });
      const contractTypes = await dispatch(sendHttpRequest(api.getContractTypes()));
      dispatch({ type: types.LOAD_CONTRACT_TYPES_SUCCEEDED, payload: contractTypes });
    } catch (error) {
      dispatch({ type: types.LOAD_CONTRACT_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAssetCategories() {
  return async (dispatch, getState) => {
    let { assetCategories } = getState().dictionaries;
    if (assetCategories.isLoaded || assetCategories.loading) return;

    try {
      dispatch({ type: types.LOAD_ASSET_CATEGORIES_STARTED });
      assetCategories = await dispatch(sendHttpRequest(api.getAssetCategories()));
      dispatch({ type: types.LOAD_ASSET_CATEGORIES_SUCCEEDED, payload: assetCategories });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadAssetClassifications() {
  return async (dispatch, getState) => {
    let { assetClassifications } = getState().dictionaries;
    if (assetClassifications.isLoaded || assetClassifications.loading) return;

    try {
      dispatch({ type: types.LOAD_ASSET_CLASSIFICATIONS_STARTED });
      assetClassifications = await dispatch(sendHttpRequest(api.getAssetClassifications()));
      dispatch({ type: types.LOAD_ASSET_CLASSIFICATIONS_SUCCEEDED, payload: assetClassifications });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPartnerPositions() {
  return async (dispatch, getState) => {
    let { partnerPositions } = getState().dictionaries;
    if (partnerPositions.isLoaded || partnerPositions.loading) return;

    try {
      dispatch({ type: types.LOAD_PARTNER_POSITIONS_STARTED });
      partnerPositions = await dispatch(sendHttpRequest(api.getPartnerPositions()));
      dispatch({ type: types.LOAD_PARTNER_POSITIONS_SUCCEEDED, payload: partnerPositions });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadContactModeTypes() {
  return async (dispatch, getState) => {
    let { contactModeTypes } = getState().dictionaries;
    if (contactModeTypes.isLoaded || contactModeTypes.loading) return;

    try {
      dispatch({ type: types.LOAD_CONTACT_MODE_TYPES_STARTED });
      contactModeTypes = await dispatch(sendHttpRequest(api.getContactModeTypes()));
      dispatch({ type: types.LOAD_CONTACT_MODE_TYPES_SUCCESS, payload: contactModeTypes });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
